<template>
   <div class="whole">
      <div class="nav">
         <van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
         <span>配置项</span>
         <div></div>
      </div>
      <div class="none" v-if="content == null || content == ''">暂无内容</div>
      <div class="main" v-else>{{content}}</div>
   </div>
</template>

<script>
   export default {
      data() {
         return {
            content: ''
         }
      },
      created() {
         this.$axios.post(baseUrl + '/mobile/Whole/wholeContent', {
            id: this.$route.query.id
         }).then((res) => {
            if (res.data.code == 2) {
               this.content = res.data.data.content;
               var imgReg = /<img.*?(?:>|\/>)/gi,
                  srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i,
                  arr = this.content.match(imgReg);
               for (var i = 0; i < arr.length; i++) {
                  var src = arr[i].match(srcReg);
                  if (src[1]) {
                     this.content = this.content.replace(src[1], baseUrl + src[1]);
                  }
               }
               var regex1 = new RegExp("(i?)(\<img)(?!(.*?style=['\"](.*)['\"])[^\>]+\>)", "gmi");
               this.content = this.content.replace(regex1, "$2 style=\"\"$3");
               var regex2 = new RegExp("(i?)(\<img.*?style=['\"])([^\>]+\>)", "gmi");
               this.content = this.content.replace(regex2,
                  "$2max-width:100%;width:100%;height:auto;$3");
            }
         }).catch((err) => {
            console.log(err);
         })
      },
   }
</script>

<style scoped>
   .whole {
      padding-bottom: 2.5rem;
      padding-top: 2rem;
   }

   .whole .main {
      text-align: left;
      text-indent: 1rem;
      background: #fff;
      margin: 1rem 0.7rem 0 0.7rem;
      padding: 0.5rem;
      box-sizing: border-box;
      font-size: 0.8rem;
      color: #333;
      line-height: 1.7rem;
   }

   .whole .main img {
      width: 100%;
      display: block;
      object-fit: cover;
      margin-bottom: 1px;
   }

   .whole .none {
      font-size: 0.8rem;
      color: #8b8b8b;
      margin-top: 3rem;
   }
</style>


// WEBPACK FOOTER //
// src/components/home/whole/deploy.vue